import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { FollowersSummaryMap } from "./station-follower.reducer";

export const stationFollowerActions = createActionGroup({
  source: "Station Follower",
  events: {
    "Search By Stations": props<{ stationUids: string[]}>(),
    "Fetch Success": props<{ data: FollowersSummaryMap}>(),
    "Fetch Failure": props<{ message: string }>(),
    Clean: emptyProps(),
  },
});

